import { render, staticRenderFns } from "./ValueAddedServicesView.vue?vue&type=template&id=219f798d"
import script from "./ValueAddedServicesView.vue?vue&type=script&lang=js"
export * from "./ValueAddedServicesView.vue?vue&type=script&lang=js"
import style0 from "./ValueAddedServicesView.vue?vue&type=style&index=0&id=219f798d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports